<div *ngIf="loading" class="loading-container">
  <div class="dots">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>